import React from 'react';
import SvgIcon from 'utils/SvgIcon';

const CleanBuildIcon = ({ fillColor, hoverFill, style }) => (
  <SvgIcon
    {...{ fillColor, hoverFill, style }}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.0625 14.25C8.0625 15.6997 6.88725 16.875 5.4375 16.875C3.98775 16.875 2.8125 15.6997 2.8125 14.25C2.8125 13.0609 3.60319 12.0564 4.6875 11.7337V6.2663C3.60319 5.94359 2.8125 4.93913 2.8125 3.75C2.8125 2.30025 3.98775 1.125 5.4375 1.125C6.88725 1.125 8.0625 2.30025 8.0625 3.75C8.0625 4.93913 7.27181 5.94359 6.1875 6.2663V9.15626C7.15188 8.06363 8.50799 7.32494 10.0361 7.15995C10.3474 6.05773 11.3606 5.25 12.5625 5.25C14.0122 5.25 15.1875 6.42525 15.1875 7.875C15.1875 9.32475 14.0122 10.5 12.5625 10.5C11.3893 10.5 10.3959 9.73037 10.0596 8.66846C8.31513 8.91202 6.89106 10.1556 6.38533 11.8013C7.36665 12.1814 8.0625 13.1345 8.0625 14.25ZM5.4375 15.375C6.05882 15.375 6.5625 14.8713 6.5625 14.25C6.5625 13.6287 6.05882 13.125 5.4375 13.125C4.81618 13.125 4.3125 13.6287 4.3125 14.25C4.3125 14.8713 4.81618 15.375 5.4375 15.375ZM5.4375 4.875C6.05882 4.875 6.5625 4.37132 6.5625 3.75C6.5625 3.12868 6.05882 2.625 5.4375 2.625C4.81618 2.625 4.3125 3.12868 4.3125 3.75C4.3125 4.37132 4.81618 4.875 5.4375 4.875ZM12.5625 9C13.1838 9 13.6875 8.49632 13.6875 7.875C13.6875 7.25368 13.1838 6.75 12.5625 6.75C11.9412 6.75 11.4375 7.25368 11.4375 7.875C11.4375 8.49632 11.9412 9 12.5625 9Z"
    />
  </SvgIcon>
);

export default CleanBuildIcon;
